// Import Firebase modules
import { isLocalhost } from './_default.js';

// Firebase App
import { initializeApp } from "firebase/app";
import { getDatabase, ref as dbRef, push, connectDatabaseEmulator, onValue, onChildAdded, limitToLast, query, orderByChild, equalTo, off } from "firebase/database";
import { getFunctions, connectFunctionsEmulator, httpsCallable, onRequest } from "firebase/functions";
import { getStorage, connectStorageEmulator, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { getAuth, signInWithCustomToken, connectAuthEmulator, signOut, setPersistence, browserLocalPersistence } from "firebase/auth";

// Firebase configuration
// This block can be found here:
// https://console.firebase.google.com/project/olaris-ai/settings/general/
const firebaseConfig = {
  apiKey: "AIzaSyAsdGcKoSfvRG5HvpD43IfMVMAidkgLVM4",
  storageBucket: "olaris-ai.appspot.com",
  authDomain: "olaris-ai.firebaseapp.com",
  databaseURL: "https://olaris-ai-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "olaris-ai",
  storageBucket: "olaris-ai.appspot.com",
  messagingSenderId: "391154975658",
  appId: "1:391154975658:web:3f412a29f3ed2dc80361d3",
  measurementId: "G-Q9BREM98WB"
};

if (isLocalhost) {
  firebaseConfig.databaseURL = "https://olaris-ai.firebaseio.com";
}

// Initialize Firebase
const functionRegion = 'europe-west6';
const firebaseApp = initializeApp(firebaseConfig);
const database = getDatabase(firebaseApp);
const storage = getStorage(firebaseApp);
const functions = getFunctions(firebaseApp, functionRegion);
const firebaseAuth = getAuth(firebaseApp);

// Check if running on localhost
if (isLocalhost) {
  connectStorageEmulator(storage, "localhost", 9199);
  connectFunctionsEmulator(functions, "localhost", 5001);
  connectDatabaseEmulator(database, "localhost", 9000);
  connectAuthEmulator(firebaseAuth, "http://localhost:9099");
}

// Export initialized services
export { firebaseApp, database, storage, functions, httpsCallable, ref, uploadBytes, getDownloadURL, dbRef, push, onValue, onChildAdded, limitToLast, query, getAuth, signInWithCustomToken, signOut, orderByChild, equalTo, off, firebaseAuth, setPersistence, browserLocalPersistence };
